<template>
  <div class="collect">
    <div class="search-warehouse">
      <div class="add">
        <el-button class="btn-blue" @click="add">新增采集人员</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="brandList" style="width: 100%"
      :row-class-name="tableRowClassName">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="mod(scope.row)">编辑</el-button>
            <el-button class="btn-text" type="text" @click="updateStatus(scope.row)">
              {{ scope.row.status?'关闭':'开启'}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <pagination-tpl
        :total="setBrandPage.total"
        :currentPage="setBrandPage.currentPage"
        :pageSize="setBrandPage.pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>
    <!-- 添加品牌/编辑 -->
    <el-dialog
      :title="brandForm.id ? '编辑' : '新增'"
      top="26vh"
      :visible.sync="brandDialog"
      width="420px"
    >
      <div class="border"></div>
      <el-form
        ref="brandForm"
        :model="brandForm"
        :rules="brandFormRules"
      >
        <el-form-item label="品牌" prop="name">
          <el-input v-model="brandForm.name" class="white" placeholder="请输入品牌"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeBrandDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveCollect('brandForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import BrandMixins from "common/mixins/smart-vehicle-inspection/brand";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  mixins: [BrandMixins],
  data() {
    return {
      tableTitleList: [
        {label: '序号', prop: 'sort'}, 
        {label: '品牌', prop: 'name'}
      ],
      brandDialog: false,
      brandForm: {
        id: '',
        name: ''
      },
      brandFormRules: {
        name: [
          { required: true, message: "请输入品牌", trigger: "blur" },
        ]
      }
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('品牌维护')
    this.initBrandList();
  },
  methods: { 
    tableRowClassName({ row }) {
      if (row.status !== 1) {
        return "close-row";
      }
    },
    //翻页
    queryChange(data) {
      this.setBrandPage.currentPage = data.currentPage;
      this.initBrandList();
    },
    //新增
    add() {
      this.brandDialog = true;
    },
    closeBrandDialog() {
      this.brandForm.id = ''
      this.brandForm.name = ''
      this.brandDialog = false;
    },
    saveCollect(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.brandForm.id) {
            let data = {};
            data.id = this.brandForm.id;
            data.name = this.brandForm.name;
            SmartVehicleInspection.postModBrand(data).then(res => {
              if (res.success) {
                this.initBrandList();
                this.closeBrandDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.brandForm.name;
            SmartVehicleInspection.postAddBrand(data).then(res => {
              if (res.success) {
                this.initBrandList();
                this.closeBrandDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    mod(row) {
      this.brandForm.id = row.id
      this.brandForm.name = row.name
      this.add()
    },
    updateStatus(row) {
      const title = row.status?'是否关闭该品牌？':'是否开启该品牌？' 
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => {});
    },

    commonFun(row) {
      const data = {
        id: row.id,
        status: row.status?0:1,
      } 
      SmartVehicleInspection.postUpdateBrandStatus(data).then(res => {
        if (res.success) {
          this.initBrandList();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.collect {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #b7b7b7;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  
  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
    .el-dialog__body {
      padding: 0px;
      .el-form {
        padding: 20px;
        .el-form-item {
          .el-form-item__label {
            width: 100%;
            text-align: left;
          }
          .el-form-item__content {
            width: 100%;
          }
        }
      }
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
    }
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
  
}
</style>
